import { Box } from '@mui/material';
import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { AutomationDialogContent } from '../Automations/AutomationDialogContent';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../pages/environments/environmentsReducer';
import useAutomationApiPerType from '../Automations/useAutomationApiPerType';
import { selectScheduledAssignments } from '../../reducers/global/scheduledAssignmentReducers';
import { scheduledAssignmentsSortOptions } from '../Automations/consts';
import { AutomationScheduledAssignmentsContextProvider } from './AutomationScheduledAssignmentsContextProvider';
import { useGetScheduledAssignmentFilters } from '../Automations/filters/helpers';
import useObjectTypesWithFetch from '../../hooks/useObjectTypesWithFetch';

interface ScheduledAssignmentsProps {
  disableCanvasTemplates?: boolean;
}

const ScheduledAssignments = ({ disableCanvasTemplates }: ScheduledAssignmentsProps) => {
  const scheduledAssignments = useSelector(selectScheduledAssignments);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant: AutomationFormVariant.SCHEDULED_ASSIGNMENTS });

  const { objectTypesByName } = useObjectTypesWithFetch({ crmOrgId: crmOrg?.id ?? '' });
  const filters = useGetScheduledAssignmentFilters(scheduledAssignments, objectTypesByName);

  if (!scheduledAssignments) return <CenteredCircularProgress />;

  return (
    <Box pb={2} flex={1} height="100%">
      {crmOrg && (
        <AutomationDialogContent
          automations={scheduledAssignments ?? []}
          onDeleteAutomation={onDeleteAutomation}
          crmOrgId={crmOrg.id}
          onSaveOrCreate={onSaveOrCreate}
          onToggleActivation={onToggleActivation}
          sortOptions={scheduledAssignmentsSortOptions}
          disableCanvasTemplates={disableCanvasTemplates}
          onDeployAutomation={onDeployAutomation}
          filters={filters}
        />
      )}
    </Box>
  );
};

const ScheduledAssignmentsWithContext = (scheduledAssignmentProps: ScheduledAssignmentsProps) => {
  return (
    <AutomationScheduledAssignmentsContextProvider>
      <ScheduledAssignments {...scheduledAssignmentProps} />
    </AutomationScheduledAssignmentsContextProvider>
  );
};

export default ScheduledAssignmentsWithContext;
